var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteboardDisplayEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    className: "st0",
    width: 26,
    height: 18
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10,30 13,21 19,21 22,30 "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 25,
    x2: 20,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#17BF87",
    strokeWidth: 4,
    x1: 16,
    y1: 17,
    x2: 16,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#17BF87",
    strokeWidth: 4,
    x1: 12,
    y1: 11,
    x2: 16,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#17BF87",
    strokeWidth: 4,
    x1: 16,
    y1: 7,
    x2: 20,
    y2: 11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboardDisplayEnable);
export default __webpack_public_path__ + "static/media/whiteboard-display-enable.40a51f19cc93dee975a6fd7d6d09e7c9.svg";
export { ForwardRef as ReactComponent };